import React, { useEffect, useRef, useState } from "react"
import {
  Badge,
  Container,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import { Editor } from "@tinymce/tinymce-react"
import { useMemo } from "react"
import staffDocuments from "../../../assets/images/staffDocuments.jpg"
import { lettersData } from "../GenData"
import JsPDF from "jspdf"

import { useTable, usePagination, useGlobalFilter } from "react-table"
import {
  PDFViewer,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFDownloadLink,
} from "@react-pdf/renderer"
// import India from "../../../assets/images/flags/india.png"
// import Uk from "../../../assets/images/flags/uk.png"
// import InfoGif from "../../../assets/images/GIF/question-mark.gif"
import { Table, Row, Col, Card, CardBody, Modal, Form } from "reactstrap"

// assets
import "../../../assets/css/Sales/Sales.css"
import "../../../assets/css/Sales/Contract.css"
// import AccessDenied from "../../assets/images/dribbble_1.gif"

// common component
import Pagination from "components/Common/Pagination"
import ProfileDetails from "components/Common/ProfileDetails"
import axios from "axios"
import Loader from "pages/Separate/Loader"
import moment from "moment"
// import DownloadContract from "./DownloadContract"
import jsPDF from "jspdf"
import html2canvas from "html2canvas"
import configure from "configure"
import Select from "react-select"
import swal from "sweetalert"
import Swal from "sweetalert2"
import secureLocalStorage from "react-secure-storage"
import { copyToClipBoard } from "pages/Separate/copyText"
import NewPagination from "components/Common/Newpagination"
import {
  fetchData,
  fetchNodeData,
  FetchNodePostData,
} from "utils/common-fetchData"
import CopyToClipboard from "react-copy-to-clipboard"
import { ResizableBox } from "react-resizable"
import Draggable from "react-draggable"
import AppointmentPreview from "../AppointmentPreview"
import { axiosNodeInstance } from "utils/config"

// components

function TableContainer({
  columns,
  data,
  setLoading,
  setDatas,
  row,
  setRow,
  editDocID,
  editDoc,
  requirementType,
  setRequirementType,
  description,
  setDescription,
  template,
  setTemplate,
  staffIdp,
  fetchDatas,
  setLetterTemplateValue,
  letterTemplateValue,
  setLetterTypeOptions,
  letterType,
  setLetterTemplateOptions,
  letterTemplateOptions,
}) {
  const [fixedContent, setFixedContent] = useState(false)

  const [editorContent, setEditorContent] = useState(description || "")
  const [modal_large, setmodal_large] = useState(false)
  const [template_option, setTemplateOption] = useState([])

  const navigate = useNavigate()

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })
  const handleEditorChange = content => {
    setEditorContent(content || "<p></p>")
  }

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state
  useEffect(() => setPageSize(10), [])

  // const templateData = [
  //   {
  //     label: item.name,
  //     value: item.id,
  //     description: item.description,
  //   },
  // ]

  const colourStyles = {
    menuList: styles => ({
      ...styles,
      background: "white",
    }),
    menu: base => ({
      ...base,
      zIndex: 1200,
    }),
  }

  const [name_modal, setNameModal] = useState(false)

  const [title, setTitle] = useState("")

  const info = [
    {
      title: "Assigned",
      mean: " <p> <strong>Meaning :</strong> In the Mars System's Contract Module, the  <strong>Assigned</strong>column designates the specific team member or individual responsible for managing and overseeing the contract, ensuring its fulfillment and compliance.</p>",
      purpose:
        " <p> <strong>Purpose :</strong> The purpose of the <strong>Assigned</strong>  column is to establish accountability for the contract's execution and management. It helps streamline contract-related tasks, such as negotiations, amendments, and renewals, by identifying the team member or individual responsible. This column enhances teamwork, ensures effective contract administration within the Mars System, and facilitates timely contract execution.</p>",
    },
    {
      title: "Company",
      mean: "<p><strong>Meaning :</strong> In the Mars System's Contract Module, the <strong>Company</strong>  column represents the name of the organization or business entity with which the contract is established.</p>",
      purpose:
        "<p> <strong>Purpose :</strong> The purpose of the <strong>Company</strong>  column is to provide specific identification of the contracting party. It ensures that the contract is associated with the correct company, streamlining record-keeping and facilitating clear communication and contract management within the Mars System. </p>",
    },
    {
      title: "Type",
      mean: "<p><strong>Meaning :</strong> The <strong>Type</strong> column in the Mars System's Contract Module categorizes contracts into different types, such as <strong>Website Development</strong>, <strong>Digital marketing</strong>, <strong>Dedicate resource </strong>  or other relevant categories </p>",
      purpose:
        "</strong> <p> <strong>Purpose :</strong> The purpose of the <strong>Type</strong> column is to classify contracts based on their nature and purpose. It allows for easy categorization and sorting of contracts, ensuring that the Mars System users can quickly access and manage contracts based on their specific type. This column simplifies contract management and facilitates efficient contract retrieval.</p>",
    },
    {
      title: "Amount",
      mean: "<p><strong>Meaning :</strong>  In the Mars System's Contract Module, the <strong>Amount</strong> column specifies the currency in which the contract's financial terms and payments are denominated.</p>",
      purpose:
        "<p><strong>Purpose :</strong> The purpose of the <strong>Amount</strong>  column is to provide transparency regarding the currency used in the contract's financial transactions. It ensures that both parties involved in the contract are aware of the currency terms, facilitating accurate financial record-keeping and transaction management within the Mars System.</p>",
    },
    {
      title: "Duration",
      mean: "<p><strong>Meaning :</strong> : In the Mars System's Contract Module, the <strong>Duration</strong>  column indicates the period or timeframe covered by the contract, including start and end dates.</p>",
      purpose:
        "<p><strong>Purpose :</strong>The purpose of the <strong>Duration</strong>   column is to specify the contract's temporal scope. It helps users understand when the contract commences and when it expires, facilitating timely contract monitoring, renewal, and compliance tracking within the Mars System.</p>",
    },
    {
      title: "Sent Date",
      mean: " <p><strong>Meaning :</strong>The <strong>Sent Date</strong> column records the date when the contract was sent to the relevant parties for review, approval, or signature.</p>",
      purpose:
        "<p><strong>Purpose :</strong> The purpose of the <strong>Sent Date</strong> column is to track the initiation of the contract negotiation and approval process. It provides a reference point for measuring the time it takes for parties to respond and progress through the contract workflow within the Mars System.</p>",
    },
    {
      title: "End Date",
      mean: "<p><strong>Meaning :</strong>  In the Mars System's Contract Module, the <strong> End Date</strong> column denotes the date when the contract officially concludes or expires.</p>",
      purpose:
        "<p><strong>Purpose :</strong>  The purpose of the  <strong> End Date </strong> column is to provide a clear indication of when the contract's obligations and terms come to an end. It assists in contract management by ensuring that both parties are aware of the contract's termination date within the Mars System.</p>",
    },
    {
      title: "Signature",
      mean: "<p><strong>Meaning :</strong> The <strong>Signature</strong>  column may be used to record whether the contract has been signed or executed by the relevant parties. It can include indicators like <strong>Signed </strong>, <strong>Not Signed </strong>, <strong>Pending </strong>, or <strong>Won </strong>.</p>",
      purpose:
        "<p><strong>Purpose :</strong>  The purpose of the  <strong>Signature</strong> column is to track the status of contract execution. It helps users identify whether the contract has been legally binding and executed by all necessary parties. This column is crucial for ensuring compliance and contract validity within the Mars System.</p>",
    },
  ]

  // ..................................................................

  useEffect(() => {
    setTemplateOption(
      lettersData?.map(item => ({
        label: item.label,
        value: item.id,
        description: item.dec,
      }))
    )
  }, [])

  useEffect(() => {}, [])

  useEffect(() => {
    setEditorContent(description || "")
  }, [description])

  // api integration

  const handleSubmit = async e => {
    e.preventDefault()
    if (letterTemplateValue || requirementType) {
      const formData = new FormData()
      formData.append("staff_id", staffIdp)
      formData.append("letterType", requirementType.value)
      formData.append("letterTemplate", letterTemplateValue.label)
      formData.append("template_format", editorContent)
      setLoading(true)
      try {
        // const response = await axios({
        //   method: "post",
        //   url: `${configure.nodeApi}/generateStaffLetter`,
        //   data: formData,
        //   headers: {
        //     Accept: "application/json",
        //     "Content-Type": "multipart/form-data",
        //   },
        // })
        const response = await FetchNodePostData(
          setLoading,
          "generateStaffLetter",
          secureLocalStorage.getItem("auth_token"),
          formData
        )
        console.log("Response: ", response)
        if (response) {
          setLoading(false)
          Swal.fire({
            icon: "success",
            text: "Document uploaded successfully",
          }).then(() => {
            setRequirementType(null)
            setDescription("")
            // setDatas(response.data.data);
            fetchDatas()
            setRow(1)
          })
        }
      } catch (error) {
        console.log(error)
        setLoading(false)
      }
    } else {
      Swal.fire({
        icon: "warning",
        text: `${letterTemplateValue}, ${requirementType}`,
      })
    }
  }
  //
  const handleEditDoc = async e => {
    e.preventDefault()
    if (letterTemplateValue || requirementType) {
      const formData = new FormData()
      formData.append("staff_id", staffIdp)
      formData.append("letter_id", editDocID)
      formData.append("requirement_type", requirementType.value)
      formData.append("letterTemplate", letterTemplateValue.label)
      formData.append("template_format", editorContent)
      setLoading(true)
      try {
        const response = await FetchNodePostData(
          setLoading,
          "generateStaffLetter/edit",
          secureLocalStorage.getItem("auth_token"),
          formData
        )
        if (response) {
          setLoading(false)
          Swal.fire({
            icon: "success",
            text: "Document edited successfully",
          }).then(() => {
            setRequirementType(null)
            setDescription("")
            // setDatas(response.data.data);
            fetchDatas()
            setRow(1)
          })
        }
      } catch (error) {
        console.log(error)
        setLoading(false)
      }
    } else {
      console.log(`${letterTemplateValue.value}, ${requirementType.value}`)
      Swal.fire({
        icon: "warning",
        text: "Please select document type",
      })
    }
  }

  const fetchLetterTypes = async () => {
    console.log("Function Called")
    const response = await fetchNodeData(
      setLoading,
      `LetterTypes`,
      secureLocalStorage.getItem("auth_token")
    )
    console.log("response: ", response)
    if (response.status) {
      const formatted = response.data.map(x => ({
        value: x.id,
        label: x.LetterName,
      }))
      setLetterTypeOptions(formatted)
    } else {
      setLetterTypeOptions([])
    }
  }
  useEffect(() => {
    fetchLetterTypes()
  }, [])

  const fetchLetterTemplateOptions = async data => {
    const response = await fetchNodeData(
      setLoading,
      `staffTemplate/Options/${data?.value}`
    )
    console.log("response: ", response)
    if (response?.data?.success || response?.success) {
      const formatted = response.data.map(x => ({
        value: x.id,
        label: x.name,
        template: x.description,
      }))
      setLetterTemplateOptions(formatted)
    }
    console.log("fetchLetterTemplateOptions: ", letterTemplateOptions)
    console.log("this function is called")
  }

  return (
    <div>
      {row == 1 ? (
        <div>
          {/* fixed buttons */}
          <div
            className={`flex-column fixed-buttons ${
              fixedContent ? "d-flex" : "d-none"
            }`}
          >
            <button
              //   to={`${configure.appUrl}sales/add-contract`}
              className="btn btn-purple  fix-btn"
              type="button"
              onClick={() => setRow(2)}
            >
              <i className="fas fa-plus me-2 icon-size"></i>
              <span>Generate</span>
            </button>
            <button
              onClick={() => navigate(-1)}
              className="btn btn-red  fix-btn"
              type="button"
            >
              <i className="dripicons-cross me-2 icon-center"></i>
              <span>Cancel</span>
            </button>
          </div>
          <Row className="mb-2">
            <Col>
              <select
                className=" me-4 form-select"
                style={{ width: "100px" }}
                value={pageSize}
                onChange={e => setPageSize(e.target.value)}
              >
                {[10, 25, 50, 100].map(pageSize => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select>
            </Col>
            <Col className="d-flex justify-content-end col-md-10">
              <div className="me-4">
                <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
                  <div className="position-relative">
                    <label htmlFor="search-bar-0" className="search-label">
                      <span id="search-bar-0-label" className="sr-only">
                        Search this table
                      </span>
                      <input
                        onChange={e => setGlobalFilter(e.target.value)}
                        id="search-bar-0"
                        type="text"
                        className=" form-control rounded h-100"
                        placeholder={` Search...`}
                        value={globalFilter || ""}
                      />
                    </label>
                    <i className="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
              <div className="text-md-end">
                {/* <button
              onClick={() => setFormPopup(!formPopup)}
              className="btn btn-outline-secondary  me-3"
            >
              <i className="fas fa-filter"></i>
            </button> */}
                <button
                  type="button"
                  className=" btn text-white me-2 btn-purple"
                  onClick={() => setRow(2)}
                >
                  <i className="fas fa-plus me-2 icon-size"></i>Generate
                  Document
                </button>
                <button onClick={() => navigate(-1)} className=" btn btn-red">
                  <i className="dripicons-cross me-2 icon-center"></i>CANCEL
                </button>
              </div>
            </Col>
          </Row>
          <div className="row">
            {/* <div className="col-md-3 d-flex justify-content-center pt-4">
              <div className={`${fixedContent ? "staffDocuments" : ""}`}>
                <img
                  src={staffDocuments}
                  alt="staffDocuments"
                  className="w-100"
                />
              </div>
            </div> */}
            <div className="col-12">
              <div className="position-relative">
                <Table
                  className="table table-bordered mt-4"
                  {...getTableProps()}
                >
                  <thead
                    className={`fix-genrateDoc-header ${
                      fixedContent ? "fix-header-genrateDoc" : ""
                    } `}
                  >
                    {headerGroups.map((headerGroup, i) => (
                      <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column, index) => (
                          <th
                            key={index}
                            className={`t-col-${index + 1} ${column.className}`}
                            {...column.getHeaderProps()}
                          >
                            {column.render("Header")}
                            {column.isInfoIcon ? (
                              <a
                                onClick={() => {
                                  setNameModal(true)
                                  setTitle(column.Header)
                                }}
                              >
                                <i
                                  title="info"
                                  className="bx bx-info-circle ms-1 info-icon"
                                ></i>
                              </a>
                            ) : null}
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>

                  <tbody
                    className="fix-genrateDoc-header"
                    {...getTableBodyProps()}
                  >
                    {page.map((row, i) => {
                      prepareRow(row)
                      return (
                        <tr
                          className="row-hover"
                          {...row.getRowProps()}
                          key={i}
                        >
                          {row.cells.map((cell, index) => {
                            return (
                              <td
                                key={index}
                                onClick={() =>
                                  cell.column.Header === "Company"
                                    ? navigate(
                                        `${configure.appUrl}sales/edit-contract`
                                      )
                                    : ""
                                }
                                className={`t-col-${index + 1} ${
                                  cell.column.className
                                } ${
                                  cell.column.Header === "Signature"
                                    ? cell.value === "Not-Signed"
                                      ? "text-danger"
                                      : "text-success"
                                    : ""
                                }`}
                                {...cell.getCellProps()}
                              >
                                {cell.render("Cell")}
                              </td>
                            )
                          })}
                        </tr>
                      )
                    })}
                    {page.length == 0 && (
                      <tr>
                        <td className="text-center" colSpan={10}>
                          No Data found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>

          {/* Pagination */}
          <Row className="justify-content-md-end justify-content-center align-items-center">
            <NewPagination
              gotoPage={gotoPage}
              canPreviousPage={canPreviousPage}
              previousPage={previousPage}
              canNextPage={canNextPage}
              pageIndex={pageIndex}
              pageOptions={pageOptions}
              pageSize={pageSize}
              page={page}
              data={data}
              nextPage={nextPage}
            />
          </Row>

          <Modal
            isOpen={name_modal}
            toggle={() => {
              tog_center()
            }}
            className="bd-info-popup"
            centered
          >
            <div className="modal-header bd-head-info">
              <h5 className="modal-title mt-0">
                <i className="dripicons-information bd-transform-icon pr-10 text-red"></i>
                {title}
              </h5>
            </div>
            <div className="modal-body pb-0">
              <div className="d-flex">
                <div className="col-5 pr-30">
                  {/* <div>
                <img src={InfoGif} className="w-100" />
              </div> */}
                </div>
                <div className="mt-20 ">
                  <div>
                    {info.map((item, i) => {
                      if (item.title == title) {
                        return (
                          <div key={i}>
                            <span>
                              <span
                                dangerouslySetInnerHTML={{ __html: item.mean }}
                              ></span>
                            </span>
                            <div
                              dangerouslySetInnerHTML={{ __html: item.purpose }}
                            ></div>
                          </div>
                        )
                      }
                    })}
                    <div></div>
                    <div className="text-center mt-70">
                      <button
                        type="button"
                        className="btn btn-success "
                        onClick={() => setNameModal(false)}
                      >
                        I Understood
                        <i className="dripicons-thumbs-up pl-10"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      ) : row == 2 ? (
        <div>
          <form onSubmit={handleSubmit}>
            <div
              className={`flex-column fixed-buttons pt-2 ${
                fixedContent ? "d-flex" : "d-none"
              }`}
            >
              <button
                type="submit"
                className="btn btn-save  fix-btn btn-label pe-0"
              >
                <i className="fas fa-save me-2 label-icon label-icon"></i>
                <span>Save</span>
              </button>
              <button
                type="button"
                onClick={() => {
                  setRequirementType(null)
                  setLetterTemplateValue(null)
                  setDescription("")
                  setRow(1)
                }}
                className="btn btn-red  fix-btn btn-label pe-0"
              >
                <i className="dripicons-cross me-2 icon-center label-icon"></i>
                <span>Cancel</span>
              </button>
            </div>

            <div className="h-100 bg-white px-4">
              <Row className="py-4 h-100 mb-3">
                <div className="row mb-3 align-items-start justify-content-between">
                  {/* Left Group: Document Inputs */}
                  <div className="col-md-7">
                    <div className="row mb-3">
                      {/* Document Type */}
                      <div className="col-md-4 mb-3">
                        <label htmlFor="">
                          Document Type <span>*</span>
                        </label>
                        <Select
                          value={requirementType}
                          placeholder="Select Type"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          styles={colourStyles}
                          options={letterType}
                          // onChange={e => {
                          //   setRequirementType(e)
                          //   setTemplate(e)
                          //   setDescription(e.description)
                          // }}
                          onChange={e => {
                            setLetterTemplateValue(null)
                            setRequirementType(e)
                            fetchLetterTemplateOptions(e)
                          }}
                        />
                      </div>

                      {/* Document Template */}
                      <div className="col-md-5">
                        <label htmlFor="">
                          Document Template <span>*</span>
                        </label>
                        <Select
                          value={letterTemplateValue}
                          placeholder="Select Template"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          styles={colourStyles}
                          options={letterTemplateOptions}
                          onChange={e => {
                            // setRequirementType(e)
                            console.log("e: ", e)
                            setLetterTemplateValue(e)
                            setDescription(e?.template)
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Right Group: Buttons */}
                  <div className="col-md-5 d-flex justify-content-end align-items-start">
                    <div className="btn-group">
                      <a
                        onClick={() => setmodal_large(true)}
                        className="btn btn-save me-2"
                      >
                        Dynamic Fields
                      </a>
                      <button className="btn btn-save me-2 btn-label">
                        <i className="fas fa-save me-1 label-icon"></i> Save
                      </button>
                      <a
                        onClick={() => {
                          setRequirementType(null)
                          setLetterTemplateValue(null)
                          setDescription("")
                          setRow(1)
                        }}
                        className="btn btn-red btn-label"
                      >
                        <i className="dripicons-cross me-2 icon-center label-icon"></i>{" "}
                        Cancel
                      </a>
                    </div>
                  </div>
                </div>

                {/* Editor Section */}
                <div className="col-md-12 mt-4">
                  <Editor
                    // key={row}
                    initialValue={description || ""}
                    apiKey="w6fz9u4rgsouz7jqcyy4lflpolp0tjwkx1bzoc70ntetxwys"
                    init={{
                      height: 800,
                      menubar: true,
                      plugins: [
                        "a11ychecker",
                        "accordion",
                        "advlist",
                        "advcode",
                        "advtable",
                        "autolink",
                        "checklist",
                        "export",
                        "lists",
                        "link",
                        "image",
                        "charmap",
                        "anchor",
                        "searchreplace",
                        "visualblocks",
                        "powerpaste",
                        "fullscreen",
                        "formatpainter",
                        "insertdatetime",
                        "media",
                        "table",
                        "wordcount",
                        "code",
                        "pagebreak",
                        "quickbars",
                        "codesample",
                        "textcolor",
                      ],
                      toolbar:
                        "undo redo | casechange blocks | bold italic backcolor | fontselect fontsizeselect |" +
                        "alignleft aligncenter alignright alignjustify | " +
                        "bullist numlist checklist outdent indent | removeformat | a11ycheck code table | exportpdf |",
                      fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
                    }}
                    onEditorChange={handleEditorChange}
                  />
                </div>
              </Row>
            </div>
          </form>
        </div>
      ) : row == 3 ? (
        <div>
          <form onSubmit={handleEditDoc}>
            <div
              className={`flex-column fixed-buttons pt-2 ${
                fixedContent ? "d-flex" : "d-none"
              }`}
            >
              <button
                type="submit"
                className="btn btn-save fix-btn btn-label pe-0"
              >
                <i className="fas fa-save me-2 label-icon"></i>
                <span>Update</span>
              </button>
              <button
                type="button"
                onClick={() => setRow(1)}
                className="btn btn-red fix-btn btn-label pe-0"
              >
                <i className="dripicons-cross me-2 icon-center label-icon"></i>
                <span>Cancel</span>
              </button>
            </div>

            <div className="h-100 bg-white px-4">
              <Row className="py-4 h-100 mb-3">
                <div className="row mb-3 align-items-start justify-content-between">
                  {/* Left: Document Type & Template */}
                  <div className="col-md-7">
                    <div className="row mb-3">
                      <div className="col-md-4 mb-3">
                        <label>
                          Document Type <span>*</span>
                        </label>
                        <Select
                          value={requirementType}
                          placeholder="Select Document Type"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          styles={colourStyles}
                          options={letterType}
                          onChange={async e => {
                            setRequirementType(e)
                            setLetterTemplateValue(null)
                            await fetchLetterTemplateOptions(e)
                          }}
                        />
                      </div>

                      <div className="col-md-5">
                        <label>
                          Document Template <span>*</span>
                        </label>
                        <Select
                          value={letterTemplateValue}
                          placeholder="Select Document Template"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          styles={colourStyles}
                          options={letterTemplateOptions}
                          onChange={e => {
                            setLetterTemplateValue(e)
                            setDescription(e?.template || "")
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Right: Buttons */}
                  <div className="col-md-5 d-flex justify-content-end align-items-start">
                    <div className="btn-group">
                      <a
                        onClick={() => setmodal_large(true)}
                        className="btn btn-save me-2"
                      >
                        Dynamic Fields
                      </a>
                      <button
                        type="submit"
                        className="btn btn-save me-2 btn-label"
                      >
                        <i className="fas fa-save me-1 label-icon"></i> Update
                      </button>
                      <a
                        onClick={() => setRow(1)}
                        className="btn btn-red btn-label"
                      >
                        <i className="dripicons-cross me-2 icon-center label-icon"></i>{" "}
                        Cancel
                      </a>
                    </div>
                  </div>
                </div>

                {/* Editor */}
                <div className="col-md-12 mt-4">
                  {/* <Editor
                    key={row}
                    initialValue={editorContent}
                    apiKey="w6fz9u4rgsouz7jqcyy4lflpolp0tjwkx1bzoc70ntetxwys"
                    init={{
                      height: 800,
                      menubar: true,
                      plugins: [
                        "a11ychecker",
                        "accordion",
                        "advlist",
                        "advcode",
                        "advtable",
                        "autolink",
                        "checklist",
                        "export",
                        "lists",
                        "link",
                        "image",
                        "charmap",
                        "anchor",
                        "searchreplace",
                        "visualblocks",
                        "powerpaste",
                        "fullscreen",
                        "formatpainter",
                        "insertdatetime",
                        "media",
                        "table",
                        "wordcount",
                        "code",
                        "pagebreak",
                        "quickbars",
                        "codesample",
                        "textcolor",
                      ],
                      toolbar:
                        "undo redo | casechange blocks | bold italic backcolor | fontselect fontsizeselect |" +
                        "alignleft aligncenter alignright alignjustify | " +
                        "bullist numlist checklist outdent indent | removeformat | a11ycheck code table | exportpdf |",
                      fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
                    }}
                    onEditorChange={handleEditorChange}
                  /> */}
                  <Editor
                    initialValue={description || ""}
                    apiKey="w6fz9u4rgsouz7jqcyy4lflpolp0tjwkx1bzoc70ntetxwys"
                    init={{
                      height: 800,
                      menubar: true,
                      // directionality: "ltr", // <<< ADD THIS LINE
                      plugins: [
                        "a11ychecker",
                        "accordion",
                        "advlist",
                        "advcode",
                        "advtable",
                        "autolink",
                        "checklist",
                        "export",
                        "lists",
                        "link",
                        "image",
                        "charmap",
                        "anchor",
                        "searchreplace",
                        "visualblocks",
                        "powerpaste",
                        "fullscreen",
                        "formatpainter",
                        "insertdatetime",
                        "media",
                        "table",
                        "wordcount",
                        "code",
                        "pagebreak",
                        "quickbars",
                        "codesample",
                        "textcolor",
                      ],
                      toolbar:
                        "undo redo | casechange blocks | bold italic backcolor | fontselect fontsizeselect |" +
                        "alignleft aligncenter alignright alignjustify | " +
                        "bullist numlist checklist outdent indent | removeformat | a11ycheck code table | exportpdf |",
                      fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
                    }}
                    onEditorChange={handleEditorChange}
                  />
                </div>
              </Row>
            </div>
          </form>
        </div>
      ) : (
        ""
      )}

      {/* Show dynamic field modal */}
      {/* <Modal
        size="xl"
        isOpen={modal_large}
        centered
        style={{ position: "relative", zIndex: "99999999999999999" }}
        width="600"
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Dynamic Fields</h5>
          <button
            type="button"
            onClick={() => {
              setmodal_large(false);
            }}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Row>
            <div className="d-flex flex-wrap position-relative">
              <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2 ">
                <label htmlFor="" className="col-4 mb-0">
                  Employee Name
                </label>
                <div className="p-2 me-3 col-5 bg-dynamic-field">
                  {"$emp_name"}
                </div>
                <button
                  onClick={() => copyToClipBoard(0)}
                  value="$emp_name"
                  className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary  btn-sm"
                ></button>
              </div>
              <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                <label htmlFor="" className="col-4 mb-0">
                  Joining Date
                </label>
                <div className="p-2 me-3 col-5 bg-dynamic-field">
                  {"$join_date"}
                </div>
                <button
                  onClick={() => copyToClipBoard(1)}
                  value="$join_date"
                  className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                ></button>
              </div>
              <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                <label htmlFor="" className="col-4 mb-0">
                  Employee Id
                </label>
                <div className="p-2 me-3 col-5 bg-dynamic-field">
                  {"$emp_id"}
                </div>
                <button
                  onClick={() => copyToClipBoard(2)}
                  value="$emp_id"
                  className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                ></button>
              </div>
              <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                <label htmlFor="" className="col-4 mb-0">
                  Designation
                </label>
                <div className="p-2 me-3 col-5 bg-dynamic-field">
                  {"$designation"}
                </div>
                <button
                  onClick={() => copyToClipBoard(3)}
                  value="$designation"
                  className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                ></button>
              </div>
              <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                <label htmlFor="" className="col-4 mb-0">
                  Basic Salary
                </label>
                <div className="p-2 me-3 col-5 bg-dynamic-field">
                  {"$basic_salary"}
                </div>
                <button
                  onClick={() => copyToClipBoard(4)}
                  value="$basic_salary"
                  className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                ></button>
              </div>
              <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                <label htmlFor="" className="col-4 mb-0">
                  Dearness Allowance
                </label>
                <div className="p-2 me-3 col-5 bg-dynamic-field">
                  {"$dearness_allowance"}
                </div>
                <button
                  onClick={() => copyToClipBoard(5)}
                  value="$dearness_allowance"
                  className="p-2 fas fa-copy copyBtn  h-100 col-2 btn btn-primary btn-sm"
                ></button>
              </div>
              <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                <label htmlFor="" className="col-4 mb-0">
                  House Rent Allowance
                </label>
                <div className="p-2 col-5 me-3 bg-dynamic-field">
                  {"$house_rent"}
                </div>
                <button
                  onClick={() => copyToClipBoard(6)}
                  value="$house_rent"
                  className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                ></button>
              </div>
              <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                <label htmlFor="" className="col-4 mb-0">
                  Conveyance
                </label>
                <div className="p-2 col-5 me-3 bg-dynamic-field">
                  {"$conveyance"}
                </div>
                <button
                  onClick={() => copyToClipBoard(7)}
                  value="$conveyance"
                  className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                ></button>
              </div>
              <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                <label htmlFor="" className="col-4 mb-0">
                  Address line 1
                </label>
                <div className="p-2 col-5 me-3 bg-dynamic-field">
                  {"$address_1"}
                </div>
                <button
                  onClick={() => copyToClipBoard(8)}
                  value="$address_1"
                  className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                ></button>
              </div>
              <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                <label htmlFor="" className="col-4 mb-0">
                  Address line 2
                </label>
                <div className="p-2 col-5 me-3 bg-dynamic-field">
                  {"$address_2"}
                </div>
                <button
                  onClick={() => copyToClipBoard(9)}
                  value="$address_2"
                  className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                ></button>
              </div>
              <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                <label htmlFor="" className="col-4 mb-0">
                  City
                </label>
                <div className="p-2 col-5 me-3 bg-dynamic-field">{"$city"}</div>
                <button
                  onClick={() => copyToClipBoard(10)}
                  value="$city"
                  className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                ></button>
              </div>
              <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                <label htmlFor="" className="col-4 mb-0">
                  State
                </label>
                <div className="p-2 col-5 me-3 bg-dynamic-field">
                  {"$state"}
                </div>
                <button
                  onClick={() => copyToClipBoard(11)}
                  value="$state"
                  className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                ></button>
              </div>
              <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                <label htmlFor="" className="col-4 mb-0">
                  Country
                </label>
                <div className="p-2 col-5 me-3 bg-dynamic-field">
                  {"$country"}
                </div>
                <button
                  onClick={() => copyToClipBoard(12)}
                  value="$country"
                  className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                ></button>
              </div>
              <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                <label htmlFor="" className="col-4 mb-0">
                  Pincode
                </label>
                <div className="p-2 col-5 me-3 bg-dynamic-field">
                  {"$pincode"}
                </div>
                <button
                  onClick={() => copyToClipBoard(13)}
                  value="$pincode"
                  className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                ></button>
              </div>
              <div className="copy-modal-line"></div>
            </div>
          </Row>
        </div>
      </Modal> */}
      {modal_large ? (
        <Draggable
          handle=".drag-header" // drag only by header
          bounds="body" // prevent moving off-screen
        >
          <div
            style={{
              position: "fixed",
              top: "10%", // <<< SET YOUR OWN POSITION HERE
              left: "15%",
              transform: "translateX(-50%)",
              zIndex: 999999,
            }}
          >
            {/* RESIZABLE WRAPPER */}
            <ResizableBox
              width={1000}
              height={540}
              minConstraints={[650, 350]}
              maxConstraints={[1500, 900]}
              resizeHandles={["se"]}
            >
              {/* MAIN MODAL CONTENT */}
              <div
                className="modal-content"
                style={{
                  height: "100%",
                  // overflow: "auto",
                  zIndex: 999999,
                }}
              >
                {/* HEADER (DRAG HANDLE) */}
                <div
                  className="modal-header drag-header"
                  // style={{
                  //   cursor: "move",
                  //   userSelect: "none",
                  // }}
                >
                  <h5 className="modal-title mt-0 mb-3">Dynamic Fields</h5>

                  <button
                    type="button"
                    onClick={() => setmodal_large(false)}
                    className="btn-modal-close"
                  >
                    <span aria-hidden="true" className="btn-modal-span">
                      ×
                    </span>
                  </button>
                </div>

                {/* BODY */}
                <div className="modal-body">
                  <Row>
                    <div className="d-flex flex-wrap position-relative">
                      {/* ---------------------------- */}
                      {/* FULL DYNAMIC FIELDS LIST     */}
                      {/* ---------------------------- */}

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2 ">
                        <label htmlFor="" className="col-4 mb-0">
                          Employee Name
                        </label>
                        <div className="p-2 me-3 col-5 bg-dynamic-field">
                          {"$emp_name"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(0)}
                          value="$emp_name"
                          className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Joining Date
                        </label>
                        <div className="p-2 me-3 col-5 bg-dynamic-field">
                          {"$join_date"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(1)}
                          value="$join_date"
                          className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Employee Id
                        </label>
                        <div className="p-2 me-3 col-5 bg-dynamic-field">
                          {"$emp_id"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(2)}
                          value="$emp_id"
                          className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Designation
                        </label>
                        <div className="p-2 me-3 col-5 bg-dynamic-field">
                          {"$designation"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(3)}
                          value="$designation"
                          className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Basic Salary
                        </label>
                        <div className="p-2 me-3 col-5 bg-dynamic-field">
                          {"$basic_salary"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(4)}
                          value="$basic_salary"
                          className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Dearness Allowance
                        </label>
                        <div className="p-2 me-3 col-5 bg-dynamic-field">
                          {"$dearness_allowance"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(5)}
                          value="$dearness_allowance"
                          className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          House Rent Allowance
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$house_rent"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(6)}
                          value="$house_rent"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Conveyance
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$conveyance"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(7)}
                          value="$conveyance"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Address line 1
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$address_1"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(8)}
                          value="$address_1"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Address line 2
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$address_2"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(9)}
                          value="$address_2"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          City
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$city"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(10)}
                          value="$city"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          State
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$state"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(11)}
                          value="$state"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Country
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$country"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(12)}
                          value="$country"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Pincode
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$pincode"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(13)}
                          value="$pincode"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>
                      {/* <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Company name
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$company_name"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(14)}
                          value="$company_name"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div> */}
                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Shift start and end time
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$shift_start_and_end_time"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(14)}
                          value="$shift_start_and_end_time"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>
                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Total salary
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$total_salary"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(15)}
                          value="$total_salary"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>
                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Department
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$department"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(16)}
                          value="$department"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>
                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Position
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$position"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(17)}
                          value="$position"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>
                      <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                        <label htmlFor="" className="col-4 mb-0">
                          Date of resignation
                        </label>
                        <div className="p-2 col-5 me-3 bg-dynamic-field">
                          {"$date_of_resignation"}
                        </div>
                        <button
                          onClick={() => copyToClipBoard(18)}
                          value="$date_of_resignation"
                          className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                        ></button>
                      </div>

                      <div className="copy-modal-line"></div>
                    </div>
                  </Row>
                </div>
              </div>
            </ResizableBox>
          </div>
        </Draggable>
      ) : null}
    </div>
  )
}

const GenerateDoc = ({ id, verticalActiveTab }) => {
  //meta title
  document.title = "Edit Staff | Zithas Crm"
  const [row, setRow] = useState(1)
  const [editDocID, setEditDocID] = useState("")
  const [data, setDatas] = useState([])
  const [isLoading, setLoading] = useState(false)
  const [requirementType, setRequirementType] = useState(null)
  const [staffIdp, setStaffIdp] = useState(id)
  const [letterTemplateValue, setLetterTemplateValue] = useState(null)
  const [letterType, setLetterTypeOptions] = useState([])
  const [letterTemplateOptions, setLetterTemplateOptions] = useState([])
  const [description, setDescription] = useState({
    name: "",
    description: "",
  })

  const [copy, setCopy] = useState("")
  const [copy2, setCopy2] = useState("")

  const [template, setTemplate] = useState([])

  const [previewModal, setPreviewModal] = useState(false)
  const [staffDetails, setStaffDetails] = useState({})
  const [letterTemplate, setLetterTemplate] = useState({})
  const [docFile, setdDocFile] = useState(null)

  const fetchDatas = async () => {
    try {
      setLoading(true)
      const bearerToken = secureLocalStorage.getItem("auth_token")
      const response = await axios({
        method: "get",
        url: `${configure.nodeApi}/staffLetters/${staffIdp}`,
        headers: {
          Authorization: "Bearer " + bearerToken,
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      if (response) {
        setDatas(response?.data?.data)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (verticalActiveTab == "tab8") {
      if (data?.length == 0) {
        fetchDatas()
      }
    }
  }, [verticalActiveTab])

  useEffect(() => {
    ;(async () => {
      const auth = secureLocalStorage.getItem("auth_token")
      const getData = await fetchData(null, `showStaff/${id}`, auth)
      setStaffDetails(getData?.data?.staff || {})
    })()
  }, [])

  const editDoc = async id => {
    const bearerToken = secureLocalStorage.getItem("auth_token")
    try {
      const response = await axios({
        method: "get",
        url: `${configure.nodeApi}/showStaffLetter/${id}`,
        headers: {
          Authorization: "Bearer " + bearerToken,
          Accept: "application/json",
        },
      })

      if (response?.data?.success) {
        const data = response.data.data

        // Switch to edit mode

        // Prefill TinyMCE with HTML
        setDescription(data.old_template)
        console.log("description: ", description)

        // Step 1: Fetch all letter types first
        const typesResponse = await fetchNodeData(
          setLoading,
          `LetterTypes`,
          secureLocalStorage.getItem("auth_token")
        )

        if (typesResponse?.status) {
          const formattedTypes = typesResponse.data.map(x => ({
            value: x.id,
            label: x.LetterName,
          }))

          setLetterTypeOptions(formattedTypes)

          // Step 2: Find and set correct Letter Type option
          const matchedType = formattedTypes.find(
            x => x.value == data.requirement_type
          )

          if (matchedType) {
            setRequirementType(matchedType)

            // Step 3: Fetch templates for the selected letter type
            const templatesResponse = await fetchNodeData(
              setLoading,
              `staffTemplate/Options/${matchedType.value}`,
              secureLocalStorage.getItem("auth_token")
            )

            if (templatesResponse?.data) {
              const formattedTemplates = templatesResponse.data.map(x => ({
                value: x.id,
                label: x.name,
                template: x.description,
              }))
              setLetterTemplateOptions(formattedTemplates)

              // Step 4: Find and set correct Letter Template
              const matchedTemplate = formattedTemplates.find(
                x => x.label === data.LetterTemplate
              )
              if (matchedTemplate) {
                setLetterTemplateValue(matchedTemplate)
                // setDescription(matchedTemplate?.template);
              } else {
                // fallback if template not found
                setLetterTemplateValue({
                  label: data.LetterTemplate,
                  value: null,
                })
              }
            }
            setRow(3)
            setEditDocID(id)
          } else {
            // fallback if type not found
            setRequirementType({
              label: data.requirement_type,
              value: null,
            })
          }
        }
      }
    } catch (error) {
      console.error("Error loading document:", error)
    }
  }

  const deleteDocument = id => {
    Swal.fire({
      icon: "warning",
      title: "Are you sure ?",
      text: "You want to delete document.",
      showCancelButton: true,
    }).then(async willOkay => {
      if (willOkay.isConfirmed) {
        setLoading(true)
        try {
          const formData = new FormData()
          formData.append("staff_id", staffIdp)
          formData.append("letter_id", id)
          const response = await axios({
            method: "post",
            url: `${configure.nodeApi}/deleteLetter`,
            data: formData,
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
          })
          if (response) {
            setLoading(false)
            Swal.fire({
              icon: "success",
              text: "Document deleted successfully !",
            }).then(() => {
              // const modifyArray = response?.data?.data?.filter(
              // (item) => {
              //   const type = [
              //     "salaryincrementletter",
              //     "workexperienceletter",
              //     "appointmentletter",
              //   ];
              //   const itemtypes = item.requirement_type
              //     ?.replace(/\s+/g, "")
              //     .toLowerCase();
              //   return type.includes(itemtypes);
              // }
              // );
              // setDatas(response?.data?.data);
              fetchDatas()
            })
          }
        } catch (error) {
          setLoading(false)
          console.log(error)
        }
      }
    })
  }

  async function uploadDoc(docId) {
    if (!docFile) return swal("", "Please upload pdf file", "warning")

    Swal.fire({
      icon: "warning",
      title: "Are you sure ?",
      text: `You want to upload document.`,
      showCancelButton: true,
    }).then(async willOkay => {
      if (willOkay.isConfirmed) {
        try {
          setLoading(true)
          const payload = new FormData()
          payload.append("doc_id", docId)
          payload.append("user_id", localStorage.getItem("auth_id"))
          payload.append("file", docFile)

          const apiRes = await axiosNodeInstance.post(
            "generateStaffLetter/uploadDocument",
            payload,
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
              },
            }
          )

          if (apiRes?.data?.success) {
            setLoading(false)
            Swal.fire("Success", apiRes.data.message, "success").then(() => {
              fetchDatas()
              setdDocFile(null)
            })
          }
        } catch (error) {
          console.log(error)
          swal(
            "Oops!",
            error?.response?.data?.message || error.message,
            "Something went wrong.",
            "error"
          )
        } finally {
          setLoading(false)
        }
      }
    })
  }

  // table columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        className: "text-center",
      },
      {
        Header: "Document Type",
        accessor: "LetterName",
        className: "t-md-3",
      },
      {
        Header: "Template Type",
        accessor: "letterTemplate",
        className: "t-md-3",
      },
      {
        Header: "Signature",
        accessor: "signature",
        className: "t-md-1 text-center",
        Cell: cellProps => {
          return (
            <div>
              <Badge
                className={
                  cellProps.row.original.signature != null
                    ? "bg-success text-capitalize"
                    : "bg-danger text-capitalize"
                }
              >
                {cellProps.row.original.signature != null
                  ? "Signed"
                  : "Not signed"}
              </Badge>
            </div>
          )
        },
      },
      {
        Header: "Signed Date",
        accessor: "sign_date",
        isInfoIcon: true,
        className: "t-col-2 text-center",
      },
      {
        Header: "Created",
        accessor: "created_at",
        isInfoIcon: true,
        className: "t-col-2 text-center",
        Cell: cellProps => {
          return (
            <div>
              {cellProps.row.original?.created_at != null
                ? moment(cellProps.row.original?.created_at).format(
                    "DD-MM-YYYY"
                  )
                : "-"}
            </div>
          )
        },
      },
      {
        Header: "Action",
        accessor: "action",
        className: "text-center  col-2",
        Cell: cellProps => {
          const [copied, setCopied] = useState(false)
          function copyToClipBoard(type) {
            console.log("called:")
            if (type == 1) {
              console.log("type1")
              setCopy("Copied ! ...")
            } else {
              console.log("type2")
              setCopy2("Copied ! ...")
            }
            setTimeout(() => {
              if (type == 1) {
                setCopy("")
              } else {
                setCopy2("")
              }
            }, 1000)
          }

          return (
            <div className="d-flex justify-content-center">
              {cellProps.row.original.approve == 1 &&
                cellProps.row.original.isAppointmentLetter != 1 && (
                  <a
                    href={`${configure.appUrl}viewapprovedoc/${cellProps.row.original.id}?download=1`}
                    target="_blank"
                    rel="noreferrer"
                    title="View Document"
                    className="btn btn-sm btn-outline-secondary me-1"
                  >
                    <i className="fa fa-eye pr-2"></i>
                  </a>
                )}

              {cellProps.row.original.isAppointmentLetter == 1 && (
                <>
                  {cellProps.row.original.document_link ? (
                    <a
                      className="btn btn-sm btn-purple me-2"
                      href={cellProps.row.original.document_link}
                      target="_blank"
                      rel="noreferrer"
                      title="Download signed appointment letter"
                    >
                      <i
                        className="fas fa-upload me-1"
                        style={{ fontSize: "10px" }}
                      ></i>{" "}
                      Download
                    </a>
                  ) : (
                    <>
                      <label
                        style={{ cursor: "pointer", marginBottom: 0 }}
                        className="me-1"
                        title="Upload Signed Appointment letter"
                      >
                        <input
                          type="file"
                          style={{ display: "none" }}
                          accept="application/pdf"
                          onChange={e => setdDocFile(e.target.files[0])}
                        />
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            fontSize: "11px",
                            fontWeight: 500,
                            padding: "5px 12px",
                            borderRadius: "3px",
                            border: "1px dashed #752a97",
                            color: "#752a97",
                            background: "rgba(117,42,151,0.06)",
                            whiteSpace: "nowrap",
                            transition: "background 0.2s ease",
                            maxWidth: "200px",
                            overflow: "hidden",
                          }}
                          onMouseEnter={e =>
                            (e.currentTarget.style.background =
                              "rgba(117,42,151,0.12)")
                          }
                          onMouseLeave={e =>
                            (e.currentTarget.style.background =
                              "rgba(117,42,151,0.06)")
                          }
                        >
                          <i
                            className="fas fa-upload"
                            style={{ fontSize: "10px" }}
                          ></i>
                          {docFile ? docFile.name : "Upload Letter"}
                        </span>
                      </label>
                      <button
                        onClick={() => uploadDoc(cellProps.row.original.id)}
                        className="btn btn-purple btn-sm me-2"
                      >
                        <i
                          className="fas fa-upload"
                          style={{ fontSize: "10px" }}
                        ></i>
                      </button>
                    </>
                  )}
                  <button
                    onClick={() => {
                      setPreviewModal(true)
                      setLetterTemplate(cellProps.row.original)
                    }}
                    title="View Appointment Letter"
                    className="btn btn-sm btn-outline-success me-2"
                  >
                    <i className="fas fa-book me-1"></i>
                    View
                  </button>
                </>
              )}
              <UncontrolledDropdown
                className="dropdown"
                style={{ width: "29px" }}
              >
                <DropdownToggle
                  className="btn btn-sm btn-outline-secondary w-100"
                  color="white"
                >
                  <i className="mdi mdi-dots-horizontal"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  {cellProps.row.original.approve == 1 &&
                  cellProps.row.original.allow_copy == 1 ? (
                    <CopyToClipboard
                      text={`https://edemo.zithas.com${configure.appUrl}staff/letters/${cellProps?.row?.original?.junk_id}`}
                      onCopy={() => {
                        setCopied(true)
                        setTimeout(() => setCopied(false), 1000)
                      }}
                    >
                      <button className="dropdown-item copyBtn">
                        <i className="fas fa-copy pr-10"></i>
                        {copied ? "Copied !" : "Copy Link"}
                      </button>
                    </CopyToClipboard>
                  ) : null}

                  <a
                    onClick={() => editDoc(cellProps.row.original.id)}
                    title="Edit Document"
                    className="dropdown-item"
                  >
                    <i className="fas fa-pencil-alt text-secondary pr-10"></i>{" "}
                    Edit Document
                  </a>
                  <a
                    onClick={() => deleteDocument(cellProps.row.original.id)}
                    title="delete"
                    className="dropdown-item"
                  >
                    <i className="fas fa-trash-alt text-danger pr-10"></i>{" "}
                    Delete Document
                  </a>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          )
        },
      },
    ],
    [docFile]
  )

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="bg-white">
        <Container fluid>
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer
                      columns={columns}
                      data={data}
                      setLoading={setLoading}
                      setDatas={setDatas}
                      row={row}
                      setRow={setRow}
                      editDocID={editDocID}
                      editDoc={editDoc}
                      requirementType={requirementType}
                      setRequirementType={setRequirementType}
                      description={description}
                      setDescription={setDescription}
                      template={template}
                      setTemplate={setTemplate}
                      staffIdp={staffIdp}
                      fetchDatas={fetchDatas}
                      setLetterTemplateValue={setLetterTemplateValue}
                      letterTemplateValue={letterTemplateValue}
                      setLetterTypeOptions={setLetterTypeOptions}
                      letterType={letterType}
                      letterTemplateOptions={letterTemplateOptions}
                      setLetterTemplateOptions={setLetterTemplateOptions}
                      id={id}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <AppointmentPreview
        previewModal={previewModal}
        setPreviewModal={setPreviewModal}
        staff={staffDetails}
        letterTemplate={letterTemplate}
      />
      {/* Access Denied */}
    </React.Fragment>
  )
}

export default GenerateDoc
